import { useState } from "react";
import { showSnackbar } from "../../../../Components/Snackbar/SnackbarActions";
import { useDispatch } from "react-redux";
import { utils, writeFile, write } from "xlsx";
import logoImage from "../../../../Images/acuity-logo.png";
import clientLogoDemo from "../../../../Images/demo_client_new_logo.png";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import DataService from "../../../../Service";
const useDownloads = (settings) => {
  const {
    columns,
    fileName,
    listKey,
    getData,
    role,
    userData,
    columnStyles = {},
  } = settings;
  const dispatch = useDispatch();

  const [downloading, setDownloading] = useState(false);
  const [downloadingOption, setDownloadingOption] = useState("");
  const exportCsv = () => {
    setDownloadingOption("csv");
    function downloadBlob(content, filename, contentType) {
      var blob = new Blob([content], {
        type: contentType,
      });
      var url = URL.createObjectURL(blob);
      var pom = document.createElement("a");
      pom.href = url;
      pom.setAttribute("download", filename);
      pom.click();
    }
    function arrayToCsv(data) {
      return data
        .map((row) =>
          row
            .map(String)
            .map((v) => v.replaceAll('"', '""'))
            .map((v) => `"${v}"`)
            .join(",")
        )
        .join("\r\n");
    }
    setDownloading(true);
    getData()
      .then((res) => {
        if (res?.success) {
          const columnNames = columns.map((el) => {
            return { title: el.title, field: el.field };
          });
          const newData = res[listKey]?.map((el) => {
            const newArr = [];
            columnNames.forEach((cl) => {
              const elem = el[cl.field];
              if (typeof elem === "string" || typeof elem === "number") {
                newArr.push(elem);
              } else if (!elem) {
                newArr.push("");
              } else if (Array.isArray(elem)) {
                newArr.push(elem.toString());
              }
            });
            return newArr;
          });

          let csv = arrayToCsv([columnNames.map((el) => el.title), ...newData]);

          downloadBlob(csv, `${fileName}.csv`, "text/csv;charset=utf-8;");
        }
      })
      .catch(() => {
        dispatch(
          showSnackbar("error", ["Something went wrong while downloading"])
        );
      })
      .finally(() => {
        setDownloading(false);
      });
  };

  const exportPDF = () => {
    setDownloading(true);
    setDownloadingOption("pdf");
    Promise.all([getData(), DataService.getData({}, "organisations")])
      .then((res) => {
        console.log(res, userData, "new");
        const [resData, resOrg] = res;
        const columnNames = columns
          .map((el) => {
            return { title: el.title, field: el.field };
          })
          .filter((el) => el.title !== "Assignment view");

        const newData = resData[listKey]?.map((el) => {
          const newArr = [];
          columnNames.forEach((e) => {
            newArr.push(el[e.field]);
          });
          return newArr;
        });
        console.log(columnNames, "column names", newData);
        const doc = new jsPDF({
          orientation: "landscape",
        });
        autoTable(doc, {
          headStyles: { fillColor: "rgb(7, 127, 131)" },
          columnStyles,
          head: [columnNames.map((el) => el.title)],
          body: newData,
          margin: { top: 25 },
          willDrawPage: (data) => {
            const acuityLogo = new Image();
            acuityLogo.src = logoImage;

            doc.addImage(
              acuityLogo,
              "PNG",
              doc.internal.pageSize.width - data.settings.margin.left - 70,
              7,
              70,
              16
            );
            const clientLogoSrc = resOrg.organisations.find(
              (el) =>
                el.organisation_name === userData?.organisation ||
                Number(el.id) === Number(userData?.organisation)
            );
            if (
              clientLogoSrc?.org_image_url &&
              ((userData.organisation !== "All" && role === "admin") ||
                role === "employee")
            ) {
              const clientLogo = new Image();
              clientLogo.src = clientLogoSrc?.org_image_url;

              console.log(clientLogoSrc, "src", clientLogo);

              const logoDimension = 16;
              doc.addImage(
                clientLogo,
                "PNG",
                data.settings.margin.left,
                5,
                logoDimension,
                logoDimension
              );
            }
          },
          didDrawPage: function (data) {
            // Footer
            let pageString = `${doc.getCurrentPageInfo().pageNumber}`;
            doc.setFontSize(10);
            console.log(doc, autoTable, "pdf");
            doc.setFont("helvetica");
            doc.setTextColor(119, 119, 119);
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            const creationDateString = `${moment().format(
              "MMMM Do YYYY, h:mm:ss a"
            )}`;
            doc.textWithLink(
              "www.acuitycoaching.com",
              data.settings.margin.left,
              pageHeight - 10,
              { url: "www.acuitycoaching.com" }
            );
            doc.text(
              pageString,
              doc.internal.pageSize.width / 2 - 1,
              pageHeight - 10
            );
            doc.text(
              creationDateString,
              doc.internal.pageSize.width - data.settings.margin.left - 50,
              pageHeight - 10
            );
          },
        });
        doc.save(`${fileName}.pdf`);
      })
      .catch((err) => {
        console.log(err, "Err");
        dispatch(
          showSnackbar("error", ["Something went wrong while downloading"])
        );
      })
      .finally(() => {
        setDownloading(false);
      });
  };

  const exportXLSX = () => {
    setDownloading(true);
    setDownloadingOption("xlsx");

    getData()
      .then((res) => {
        const columnNames = {};
        columns.forEach((el) => {
          columnNames[el.field] = el.title;
        });
        const newData = res[listKey]?.map((el) => {
          const newObj = {};
          for (let i in columnNames) {
            if (Array.isArray(el[i])) {
              newObj[columnNames[i]] = el[i].join(",");
            } else {
              newObj[columnNames[i]] = el[i];
            }
          }
          return newObj;
        });
        console.log(newData, "newData");
        let ws = utils.json_to_sheet(newData);
        let wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "sheet");
        writeFile(wb, `${fileName}.xlsx`);
      })
      .catch((err) => {
        console.log(err, "new");

        dispatch(
          showSnackbar("error", ["Something went wrong while downloading"])
        );
      })
      .finally(() => {
        setDownloading(false);
      });
  };
  return {
    downloading,
    setDownloading,
    downloadingOption,
    setDownloadingOption,
    exportPDF,
    exportCsv,
    exportXLSX,
  };
};
export default useDownloads;
